// extracted by mini-css-extract-plugin
module.exports = {"callFeedbackContainer":"styles_callFeedbackContainer__2RBAz","formContainer":"styles_formContainer__3gfqa","call_info":"styles_call_info__2AaSZ"};